import type { LayerControllerState } from "../layers/LayerController";
import type {
  ClearLayerCommand,
  LayerMutationAction,
  LayerMutationCommand,
  LayerStateSnapshot,
  MergeLayerDownCommand,
} from "./historyTypes";

let sequence = 0;

function id(kind: string): string {
  sequence += 1;
  return `${kind}-${sequence}`;
}

export function immutableLayerState(state: Readonly<LayerControllerState>): LayerStateSnapshot {
  return Object.freeze({
    activeLayerId: state.activeLayerId,
    layers: Object.freeze(state.layers.map((layer) => Object.freeze({ ...layer }))),
  });
}

export function createLayerMutationCommand(
  action: LayerMutationAction,
  before: Readonly<LayerControllerState>,
  after: Readonly<LayerControllerState>,
): LayerMutationCommand {
  return Object.freeze({
    kind: "layerMutation" as const,
    id: id(action),
    action,
    before: immutableLayerState(before),
    after: immutableLayerState(after),
  });
}

export function createClearLayerCommand(layerId: string): ClearLayerCommand {
  return Object.freeze({ kind: "clearLayer" as const, id: id("clear-layer"), layerId });
}

export function createMergeLayerDownCommand(
  sourceLayerId: string,
  targetLayerId: string,
  sourceOpacity: number,
  targetOpacity: number,
  before: Readonly<LayerControllerState>,
  after: Readonly<LayerControllerState>,
): MergeLayerDownCommand {
  return Object.freeze({
    kind: "mergeLayerDown" as const,
    id: id("merge-layer"),
    sourceLayerId,
    targetLayerId,
    sourceOpacity,
    targetOpacity,
    before: immutableLayerState(before),
    after: immutableLayerState(after),
  });
}
